import type { BackgroundVariantStyles } from '../../ThemeTypes';
import colors from '../colors';

const backgroundVariant: BackgroundVariantStyles = {
  bgDark: {
    backgroundColor: `${colors.dark} !important`,
  },
};

export default backgroundVariant;
